// @flow
import React from 'react';
import { Button } from '@finect/tabular-core/Button';
import { Section } from '@finect/tabular-core/Section';
import { Small } from '@finect/tabular-core/Small';
import { NewSectionInner } from './NewSection';
import { SectionTitle } from './Titles';
import { CTA } from './CTA';

type Props = {
  toggleModal: Function,
  white?: boolean
};

export const BottomCTAMortgages = ({ toggleModal, white }: Props) => (
  <Section color={white ? '' : 'grey'} textAlign="center">
    <NewSectionInner>
      <SectionTitle
        title="Da el primer paso"
        subtitle="Déjanos ayudarte a encontrar la mejor hipoteca para ti."
        maxWidth
      />
      <CTA>
        <Button onClick={() => toggleModal()}>¡Empieza ahora!</Button>
        <Small display="block" textAlign="center" margin="6px 0 0" light>
          La búsqueda es 100% gratuita.
        </Small>
      </CTA>
    </NewSectionInner>
  </Section>
);
